import { useMutation } from 'react-query';
import { BASE_URL } from '../../../constants/endpoints';

interface IProps {
    customerId: string;
    authorizedUserId: string;
    formDataInstance: FormData;
    accessToken: string;
}

const consentsData = [{ name: 'general', type: 'AUTHORIZED_VIEWER_TERM', version: '1.0' }];
export const useConsent = () => useMutation(
  'useConsent',
  async ({
    customerId, authorizedUserId, formDataInstance, accessToken,
  }: IProps) => {
    formDataInstance.append('consents', new Blob([JSON.stringify(consentsData)], { type: 'application/json' }));
    return fetch(`${BASE_URL}/api/v1/user/${customerId}/authorized/user/${authorizedUserId}/terms_and_conditions/consent`, {
      method: 'POST',
      credentials: 'omit',
      body: formDataInstance,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(() => {});
  },
);
